import { Module } from 'vuex-smart-module';
import MarketingFundActions from './actions';
import MarketingFundGetters from './getters';
import MarketingFundMutations from './mutations';
import MarketingFundState from './state';

export default new Module({
  state: MarketingFundState,
  mutations: MarketingFundMutations,
  actions: MarketingFundActions,
  getters: MarketingFundGetters,
});
